import { type PrimaryCategoryBulkReassignmentResultConstructor } from '@webapp/platform/organization-management/entities/PrimaryCategoryBulkReassignmentResult'
import { type BulkAssignLegalEntityResponseBody } from '../types/BulkAssignLegalEntityResponse'

export const mapBulkAssignLegalEntityResponseBody = (
  body: BulkAssignLegalEntityResponseBody
): PrimaryCategoryBulkReassignmentResultConstructor => ({
  movedLocations: body.moved_locations.map((location) => ({
    id: location.id,
    name: location.name,
  })),
  blockedLocations: body.blocked_locations.map((location) => ({
    id: location.id,
    name: location.name,
  })),
  blockingUsers: body.blocking_users.map((user) => ({
    userId: user.user_id,
    firstName: user.first_name,
    lastName: user.last_name,
    email: user.email,
    blockingLocationIds: user.blocking_location_ids,
  })),
})
